import { CraNodeCoding } from "../../coding/models/CraNodeCoding";
import { Score } from "@keita/lanepatrol-sdk";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { CreateCraNode, CraNode } from "../models/CraNode";
import { OptionalScope } from "../../shared/models/OptionalScope";

const prefix = "/cra-nodes";

export const CraNodeApi = {
  create: async (request: CreateCraNode) => {
    return await jwtAuthAxios().post<CraNode[]>(prefix, request);
  },

  delete: async (deletedNodeId: string) => {
    return await jwtAuthAxios().delete(`${prefix}/${deletedNodeId}`);
  },

  getScore: async (nodeId: string) => {
    return await jwtAuthAxios().get<Score | null>(`${prefix}/${nodeId}/score`);
  },

  get: async (nodeId: string, scopes: OptionalScope[] = []) => {
    return await jwtAuthAxios().get<CraNode>(`${prefix}/${nodeId}`, {
      params: {
        scopes: scopes.join(),
      },
    });
  },

  listCodingEntries: async (nodeId: string) => {
    return await jwtAuthAxios().get<CraNodeCoding>(
      `${prefix}/${nodeId}/coding`,
    );
  },

  rotate: async (nodeId: string, request: { degrees: number }) => {
    return await jwtAuthAxios().post<string>(
      `${prefix}/${nodeId}/rotate`,
      request,
    );
  },
};
